module.exports = __webpack_public_path__ + "static/media/menu.6a9ad9bd.gif";